import { styled } from '../../../stitches.config';

export const Label = styled('label', {
  fontWeight: '500',
  color: '$purple11',
});
